package com.example.mystybag.commonData.expected

import com.example.mystybag.commonData.helpers.PlatformConfig.isProductionEnvironment
import com.example.mystybag.commonData.helpers.PlatformDefines.WEB

actual fun getOS() = WEB

/**
 * Web equivalent of Android's `BuildConfig.FLAVOR_ENVIRONMENT == "Production"`.
 *
 * The flag is injected at bundle time by `composeAppWeb/webpack.config.d/custom.js`
 * via `DefinePlugin`:
 *   - `jsBrowserProductionWebpack` → `MYSTYBAG_PRODUCTION = true`
 *   - `jsBrowserDevelopmentWebpack` / `jsBrowserDevelopmentRun` → `MYSTYBAG_PRODUCTION = false`
 *
 * When `false`, [com.example.mystybag.communication.defines.CommunicationDefines]
 * routes API/static traffic to the staging environment
 * (`staging-api.mystybag.com` / `staging.mystybag.com`). Production builds keep
 * hitting `api.mystybag.com` / `www.mystybag.com`.
 *
 * Falls back to `true` if the global is missing (defensive — e.g. unit tests or
 * a webpack config that for some reason did not inject the constant).
 */
actual fun isInRelease(): Boolean {
    isProductionEnvironment?.let { return it }
    return try {
        js("(typeof MYSTYBAG_PRODUCTION !== 'undefined') ? !!MYSTYBAG_PRODUCTION : true") as Boolean
    } catch (_: Throwable) {
        true
    }
}
